import TextDecoration from "../../api/model/snapshots/layers/TextDecoration";
import RangedTextStyle from "../../api/model/textStyles/RangedTextStyle";

import { colorEquals } from "./color";

function generateTextDecorationText(textDecoration?: TextDecoration): string | null {
    if (!textDecoration) {
        return null;
    }

    return textDecoration.strikethrough ? "Strikethrough" : "Underline";
}

function textDecorationEquals(textDecoration?: TextDecoration, otherTextDecoration?: TextDecoration) {
    if (!textDecoration && !otherTextDecoration) {
        return true;
    }

    if ((textDecoration && !otherTextDecoration) || (!textDecoration && otherTextDecoration)) {
        return false;
    }

    return (
        textDecoration!.underline === otherTextDecoration!.underline &&
        textDecoration!.strikethrough === otherTextDecoration!.strikethrough
    );
}

function bothExistsAndEquals<T>(key1: T | undefined, key2: T | undefined) {
    if (key1 === undefined || key2 === undefined) {
        return true;
    }

    return key1 === key2;
}

function equals(textStyle: RangedTextStyle, otherTextStyle: RangedTextStyle, checkRange = true): boolean {
    const { range, style } = textStyle;
    const { range: otherRange, style: otherStyle } = otherTextStyle;

    const rangeEquals = checkRange ? (
        range.length === otherRange.length &&
        range.location === otherRange.location
    ) : true;

    const stlyeEquals = (
        style.fontFace === otherStyle.fontFace &&
        style.fontSize === otherStyle.fontSize &&
        style.letterSpacing === otherStyle.letterSpacing &&
        style.lineHeight === otherStyle.lineHeight &&
        style.textAlign === otherStyle.textAlign &&
        bothExistsAndEquals(style.paragraphSpacing, otherStyle.paragraphSpacing) &&
        textDecorationEquals(style.textDecoration, otherStyle.textDecoration) &&
        style.textTransform === otherStyle.textTransform &&
        bothExistsAndEquals(style.paragraphIndent, otherStyle.paragraphIndent) &&
        bothExistsAndEquals(style.listSpacing, otherStyle.listSpacing) &&
        style.verticalAlignment === otherStyle.verticalAlignment &&
        colorEquals(style.color, otherStyle.color)
    );
    return rangeEquals && stlyeEquals;
}

export { equals, generateTextDecorationText };
